export default "__VITE_ASSET__7b8b6b74__"